function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }

var SOURCE_LABELS = {
  consorcio: "Consórcio", carta_contemplada: "Carta Contemplada",
  seguro_vida: "Seguro Vida", seguro_residencial: "Seguro Residencial",
  seguro_auto: "Seguro Auto", plano_saude: "Plano Saude",
};

var SOURCE_COLORS = {
  consorcio: "bg-blue-500", carta_contemplada: "bg-indigo-500",
  seguro_vida: "bg-rose-500", seguro_residencial: "bg-amber-500",
  seguro_auto: "bg-emerald-500", plano_saude: "bg-purple-500",
};

export default function BrokerDoletasSources({ sources, totalEarned }) {
  if (!sources || sources.length === 0) return null;

  var items = [];
  for (var i = 0; i < sources.length; i++) {
    var s = sources[i];
    var pct = Math.round((s.doletas / (totalEarned || 1)) * 100);
    var colorCls = SOURCE_COLORS[s.source] || "bg-gray-500";
    items.push(
      <div key={s.source} className="flex items-center gap-3">
        <div className={"w-2 h-2 rounded-full flex-shrink-0 " + colorCls} />
        <span className="text-xs text-white/70 flex-1 truncate">{SOURCE_LABELS[s.source] || s.source}</span>
        <span className="text-xs font-medium text-white/90">{fmt(s.doletas)}</span>
        <span className="text-[10px] text-white/40 w-10 text-right">{pct}%</span>
      </div>
    );
  }

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
      <h4 className="text-xs font-medium text-white/70 mb-3">Por Produto</h4>
      <div className="space-y-2">{items}</div>
    </div>
  );
}
